import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Mock API
const api = {
  async fetchDashboardStats() {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    return {
      devices: 10,
      familyMembers: 5,
      healthyDevices: 6,
      faultyDevices: 3,
      maintenance: 1,
    };
  },
  async fetchChartData() {
    await new Promise((resolve) => setTimeout(resolve, 700));
    return [
      { month: 'JAN', value: 8 },
      { month: 'FEB', value: 12 },
      { month: 'MAR', value: 10 },
      { month: 'APR', value: 15 },
      { month: 'MAY', value: 11 },
      { month: 'JUN', value: 14 },
      { month: 'JUL', value: 18 },
      { month: 'AUG', value: 16 },
      { month: 'SEP', value: 10 },
      { month: 'OCT', value: 13 },
      { month: 'NOV', value: 17 },
      { month: 'DEC', value: 15 },
    ];
  },
  async fetchMaintenanceRequests() {
    await new Promise((resolve) => setTimeout(resolve, 600));
    return [
      {
        id: 1,
        issue: 'Faulty keyboard',
        assignedTo: {
          name: 'Ralph Edwards',
          avatar: '/placeholder.svg?height=32&width=32',
        },
        status: 'Pending',
      },
      {
        id: 2,
        issue: 'Software updates',
        assignedTo: {
          name: 'Darrell Steward',
          avatar: '/placeholder.svg?height=32&width=32',
        },
        status: 'Ongoing',
      },
      {
        id: 3,
        issue: 'Hardware issue',
        assignedTo: {
          name: 'Ralph Edwards',
          avatar: '/placeholder.svg?height=32&width=32',
        },
        status: 'Pending',
      },
      {
        id: 4,
        issue: 'Motherboard issue',
        assignedTo: {
          name: 'Eleanor Pena',
          avatar: '/placeholder.svg?height=32&width=32',
        },
        status: 'Completed',
      },
      {
        id: 5,
        issue: 'Windows crash',
        assignedTo: {
          name: 'Brooklyn Simmons',
          avatar: '/placeholder.svg?height=32&width=32',
        },
        status: 'Cancelled',
      },
    ];
  },
};

export const fetchDashboardStats = createAsyncThunk(
  'stats/fetchDashboardStats',
  async () => {
    const response = await api.fetchDashboardStats();
    return response;
  }
);

export const fetchChartData = createAsyncThunk(
  'stats/fetchChartData',
  async () => {
    const response = await api.fetchChartData();
    return response;
  }
);

export const fetchMaintenanceRequests = createAsyncThunk(
  'stats/fetchMaintenanceRequests',
  async () => {
    const response = await api.fetchMaintenanceRequests();
    return response;
  }
);

const statsSlice = createSlice({
  name: 'stats',
  initialState: {
    dashboardStats: {
      devices: 0,
      familyMembers: 0,
      healthyDevices: 0,
      faultyDevices: 0,
      maintenance: 0,
    },
    chartData: [],
    maintenanceRequests: [],
    loading: {
      stats: false,
      chart: false,
      maintenance: false,
    },
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Dashboard stats
      .addCase(fetchDashboardStats.pending, (state) => {
        state.loading.stats = true;
        state.error = null;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.loading.stats = false;
        state.dashboardStats = action.payload;
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.loading.stats = false;
        state.error = action.error.message;
      })
      // Chart data
      .addCase(fetchChartData.pending, (state) => {
        state.loading.chart = true;
        state.error = null;
      })
      .addCase(fetchChartData.fulfilled, (state, action) => {
        state.loading.chart = false;
        state.chartData = action.payload;
      })
      .addCase(fetchChartData.rejected, (state, action) => {
        state.loading.chart = false;
        state.error = action.error.message;
      })
      // Maintenance requests
      .addCase(fetchMaintenanceRequests.pending, (state) => {
        state.loading.maintenance = true;
        state.error = null;
      })
      .addCase(fetchMaintenanceRequests.fulfilled, (state, action) => {
        state.loading.maintenance = false;
        state.maintenanceRequests = action.payload;
      })
      .addCase(fetchMaintenanceRequests.rejected, (state, action) => {
        state.loading.maintenance = false;
        state.error = action.error.message;
      });
  },
});

export default statsSlice.reducer;
